module.exports = __webpack_public_path__ + "static/media/COS_CERP.9d17c7f8.png";